import HeaderNav from './headerNav';

export { headerNavStandard } from './__fixtures__/headerNav';
export { headerNavFragment } from './headerNav.fragment';

export default HeaderNav;
